export default __webpack_public_path__ + "img/LP_Explainer-Legacy-Transformation-how-it-works.1e844240.png";